module.exports = __webpack_public_path__ + "img/support_a3_1.137b531a.png";